var map = {
	"./about/clothes.png": 23,
	"./about/dancing-girl.png": 24,
	"./about/lake.png": 25,
	"./about/miranda copy.jpg": 63,
	"./about/miranda-color.jpg": 64,
	"./about/miranda.jpg": 26,
	"./about/mirror.jpg": 27,
	"./about/painting.jpg": 65,
	"./about/rocks.png": 28,
	"./arrow-right.png": 14,
	"./brush-stroke.svg": 9,
	"./burger.png": 66,
	"./contact/monk.jpg": 67,
	"./destinations/africa/camp.jpg": 29,
	"./destinations/africa/elephant.png": 68,
	"./destinations/africa/giraffe.png": 30,
	"./destinations/africa/lamp.jpg": 31,
	"./destinations/africa/spa.jpg": 32,
	"./destinations/asia/boats.jpg": 33,
	"./destinations/asia/crab.jpg": 34,
	"./destinations/asia/house-boat.jpg": 35,
	"./destinations/asia/woman.jpg": 36,
	"./destinations/europe/church.jpg": 69,
	"./destinations/europe/colloseum.png": 70,
	"./destinations/europe/doorways.jpg": 71,
	"./destinations/europe/goat.jpg": 72,
	"./destinations/europe/loom.jpg": 73,
	"./destinations/europe/skyros.jpg": 74,
	"./destinations/europe/soup.png": 75,
	"./destinations/europe/woman.jpg": 76,
	"./destinations/middle-east/camel.jpg": 77,
	"./destinations/middle-east/jesus.jpg": 37,
	"./destinations/middle-east/palace.png": 38,
	"./destinations/south-america/cheese.jpg": 39,
	"./destinations/south-america/fruit.jpg": 40,
	"./destinations/south-america/horse.jpg": 41,
	"./destinations/south-america/sky.jpg": 42,
	"./destinations/usa-and-canada/all-roads-north.jpg": 43,
	"./destinations/usa-and-canada/fogo.png": 44,
	"./destinations/usa-and-canada/lighthouse.png": 45,
	"./destinations/usa-and-canada/monastery.jpg": 46,
	"./destinations/usa-and-canada/oxomoco.jpg": 78,
	"./destinations/worker.jpg": 79,
	"./exit.png": 80,
	"./home/elephant.jpg": 81,
	"./lantern.jpg": 17,
	"./logo.png": 16,
	"./logo.svg": 82,
	"./logo2.png": 83,
	"./services/Scheduled-Group-Departures.jpg": 84,
	"./services/boat.jpg": 85,
	"./services/lake.jpg": 86,
	"./services/sandals.jpg": 47,
	"./stories.jpg": 87
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;